export const HEATMAP_CONFIG = {
  0: { color: "#F4F4F5", label: "0 hours" },
  1: { color: "#86EFAC", label: "0.1-2 hours" },
  2: { color: "#22C55E", label: "2.1-4 hours" },
  3: { color: "#16A34A", label: "4.1-6 hours" },
  4: { color: "#14532D", label: "6+ hours" },
};

export const DASHBOARD_STATS_INFO = {
  budgetVsAchieved: "Indicates performance against the budgeted margin: below 100 indicates underperformance, 100 indicates expected performance, and above 100 indicates exceptional performance.",
  billableRevenue: "Total billable revenue of the work done till date for the project.",
  billedRevenue: "Total revenue actually billed for the project.",
  netCost: "Total actual/approved cost based on the approved hours for the project.",
  achievedRevenue: "This is the actual profit amount in INR i.e the actual profit earned after deducting net cost from billed revenue.",
  inventory: "Revenue that is earned/billable but not yet billed.",
  prepaid: "Amount billed in advance of the billable revenue",
  backlog: "Revenue allocated to work that is yet to be billed to the client, after deducting any amount already billed in advance.",
  approvedVsLogged: "Shows comparision between Approved hours against Logged hours.",
  allocatedRevenue: "Total Revenue of a project",
}
